import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputLabelFn = /* @__PURE__ */ createRecipe('input-label', {
  "size": "l",
  "color": "neutral",
  "weight": "medium"
}, [])

const inputLabelVariantMap = {
  "size": [
    "l",
    "m"
  ],
  "display": [
    "desktop"
  ],
  "color": [
    "neutral",
    "primary"
  ],
  "weight": [
    "medium",
    "bold"
  ]
}

const inputLabelVariantKeys = Object.keys(inputLabelVariantMap)

export const inputLabel = /* @__PURE__ */ Object.assign(memo(inputLabelFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputLabel',
  __getCompoundVariantCss__: inputLabelFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputLabelVariantKeys,
  variantMap: inputLabelVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputLabelVariantKeys)
  },
  getVariantProps: inputLabelFn.getVariantProps,
})